var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeat01 = function SvgRepeat01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.004 13.154v5.79H6.093l1.915 1.914L6.898 22l-3.845-3.846 3.845-3.846 1.11 1.141-1.915 1.915h11.332v-4.21zm1.944-7.308-3.846 3.846-1.11-1.141 1.915-1.915H6.575v4.21H4.996v-5.79h12.911l-1.915-1.914L17.102 2z"
  })));
};
export default SvgRepeat01;